import {
    get_clienti,
    create_cliente,
    update_cliente,
    duplica_cliente,
    delete_cliente,
} from "@/api/api.cliente.js";

const clienti = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_clienti().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati }) {
            const call = id ? update_cliente(id, dati) : create_cliente(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                delete_cliente(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        duplica({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                duplica_cliente(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default clienti;
